import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import BoxComponent from "../../../components/Box/BoxComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import TextFieldComponent from "../../../components/TextField/TextFieldComponent";
import LabelComponent from "../../../components/Label/LabelComponent";
import { ModalMovimentoConfirmProps } from "../CaixaPage";

interface ModalCriaMovimentoProps {
    open: boolean;
    title: string;
    onClose: () => void;
    onConfirm: (data: ModalMovimentoConfirmProps) => void;
    valor?: string;
    onChangeValor: (valor: string) => void;

    observacao?: string
    onChangeObservacao: (observacao: string) => void;

    valorEsperado?: string;
    valorInformado?: string;
    onChangeValorInformado: (valorInformado: string) => void;
}

const ModalCriaMovimentoComponent = (props: ModalCriaMovimentoProps) => {
    const handleConfirm = () => {
        props.onConfirm({
            valor: String(props.valor),
            observacao: String(props.observacao),        
            valorInformado: String(props.valorInformado)
        });
        props.onClose();
    };

    const labelStyle = {
        fontFamily: '"Font 7", sans-serif',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0em',
        color: '#666666',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        textTransform: 'none'
    };

    const inputStyle = {
        // width: '336px',
        height: '42px',
        width: "100%",
        borderRadius: '8px',
        border: '1px solid #E0E0E0',
        //padding: '0 12px', // Espaçamento interno padrão para texto não grudar na borda
        boxSizing: 'border-box',
        outline: 'none',
        backgroundColor: '#FFFFFF',
        // Aplicando a Font 7 que estávamos usando para manter a consistência
        fontFamily: '"Font 7", sans-serif',
        fontSize: '14px',
        color: '#333333',
        '&:focus': {
            borderColor: '#FF8C42', // Sugestão de cor de foco baseada no seu padrão anterior
        },
        "& .MuiInputBase-formControl": {
            height: "100%"
        }
    }

    return <Dialog open={props.open} onClose={props.onClose} maxWidth={false} sx={{
        display: "flex",
        justifyContent: "center",
        height: "100dvh",
        width: "100vw",
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
                width: "384px",
            },
        },
    }} fullWidth>
        <DialogTitle
            sx={{
                fontFamily: '"Font 7", sans-serif',
                fontWeight: 600,
                fontSize: '18px',
                lineHeight: '28px',
                letterSpacing: '0em',
                color: '#333333',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle',
                textTransform: 'none'
            }}
        >{props.title}
        </DialogTitle>

        <DialogContent>
            <BoxComponent component="div">
                {(props.title === "Sangria" || props.title === "Suprimento") && (
                    <>
                        <LabelComponent htmlFor="valor" sx={labelStyle}>
                            Valor
                        </LabelComponent>
                        <TextFieldComponent
                            id="valor"
                            placeholder="0,00"
                            value={props.valor}
                            onChange={(e) => props.onChangeValor(e.target.value)}
                            fullWidth
                            sx={inputStyle}
                        />
                        <LabelComponent htmlFor="observacao" sx={labelStyle}>
                            Observação
                        </LabelComponent>
                        <TextFieldComponent
                            id="observacao"
                            placeholder="Digite uma observação..."
                            value={props.observacao}
                            onChange={(e) => props.onChangeObservacao(e.target.value)}
                            fullWidth
                            rows={3}
                            multiline
                            sx={{...inputStyle, height: "auto"}}
                        />
                    </>
                )}
                {props.title === "Fechar Caixa" && (
                    <>
                        <LabelComponent sx={labelStyle} htmlFor="valor_esperado">
                            Valor Esperado
                        </LabelComponent>
                        <TextFieldComponent
                            id="valor_esperado"
                            value={props.valorEsperado}
                            fullWidth
                            disabled
                            sx={{...inputStyle, background: "#F8F5F0", border: "1px solid  #E0E0E0"}}
                        />
                        <LabelComponent htmlFor="valor_informado" sx={labelStyle}>
                            Valor Informado
                        </LabelComponent>
                        <TextFieldComponent
                            id="valor_informado"
                            placeholder="0,00"
                            value={props.valorInformado}
                            onChange={(e) => props.onChangeValorInformado(e.target.value)}
                            fullWidth
                            sx={inputStyle}
                        />
                    </>
                )}
            </BoxComponent>
        </DialogContent>

        <DialogActions sx={{
            display: "flex",
            justifyContent: "center"
        }}>
            <ButtonComponent
                id="close_modal" onClick={props.onClose}
                sx={{
                    width: '163px',
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    borderRadius: '8px',
                    border: '1px solid #E0E0E0',
                    padding: '8px 16px', // Conforme sua especificação (top/bottom e right/left)
                    opacity: 1,
                    backgroundColor: '#FFFFFF',
                    // Estilos de texto baseados nos padrões que definimos antes
                    fontFamily: '"Font 7", sans-serif',
                    fontSize: '14px',
                    color: '#333333',
                    textTransform: "initial"
                }}
            >
                Cancelar
            </ButtonComponent>
            <ButtonComponent
                id="confirm_modal" onClick={handleConfirm}
                sx={{
                    width: '161px',
                    height: '42px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    borderRadius: '8px',
                    border: 'none',
                    padding: '9px 16px', // Padding vertical levemente maior (9px)
                    backgroundColor: '#FF8C42',
                    color: '#FFFFFF',
                    cursor: 'pointer',
                    opacity: 1,
                    // Aplicando a Font 7 Semi Bold 14px (que combina com CTAs)
                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    transition: 'filter 0.2s',
                    '&:hover': {
                        filter: 'brightness(0.9)', // Efeito sutil ao passar o mouse
                    },
                    textTransform: "initial"
                }}
            >
                Confirmar
            </ButtonComponent>
        </DialogActions>
    </Dialog >
}

export default ModalCriaMovimentoComponent;